import { render } from "./AppFooter.vue?vue&type=template&id=72033271"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=72033271&lang=css"

import exportComponent from "/Users/ts/Desktop/works/lancers_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__